<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs6 md6 sm6>
          <h3 class="pull-right mt-0" v-if="professional && professional.id">View Professional</h3>
        </v-flex>
        <v-flex xs6 md6 sm6>
          <v-btn small @click="goTo('/user/professional/edit')" class="primary pull-right" title="Edit" v-if="professional && professional.id">
            <v-icon left>mdi-lead-pencil</v-icon>Edit
          </v-btn>
          <v-btn small @click="create = !create" class="primary pull-right" title="Create" v-else>
            <v-icon left>mdi-briefcase-plus</v-icon>Add Professional Profile
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md6 v-if="professional">
          <v-card>
            <v-card-title>
              Requests Claimed
              <v-spacer></v-spacer>
              <v-text-field label="Search" v-model="filterBy" prepend-inner-icon="mdi-card-search-outline"></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table dense :items="service_requests" :headers="headers" :search="filterBy">
                <template v-slot:[`item.id`]="{ item }">
                  <inertia-link :href="'/user/professional/service_requests/' + item.id">{{ moment(item.created_at).format('dddd MMMM D, yyyy H:m') }}</inertia-link>
                </template>
                <template v-slot:[`item.visit_id`]="{ item }">
                  <inertia-link :href="'/clients/' + item.client_id + '/visits/' + item.visit_id" v-if="item.visit_id">View</inertia-link>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn small icon title="Delete Request" color="red" @click="deleteRequest(item)" v-if="can.hasOwnProperty('service_requests.delete')">
                    <v-icon>{{ icons.delete }}</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm10 md6>
          <v-sheet class="px-1" v-if="professional && professional.id">
            <view-professional :professional="professional" v-if="professional && professional.id"></view-professional>
            <v-sheet v-if="!professional.profile_photo_path">
              <v-form v-model="valid">
                <v-file-input :rules="[sizerules, form_rules.required]" @change="checkImage" accept="image/png, image/jpeg, image/bmp" placeholder="Pick an avatar" prepend-icon="mdi-camera" label="Avatar" persistent-hint hint="This photo will be shown to users when you claim their request." ref="photo"></v-file-input>
                <v-btn small class="pull-right" :disabled="!valid" @click="saveImage">Upload</v-btn><br>
              </v-form>
              <hr class="transparent">
            </v-sheet>
            <v-sheet class="px-1">
              <v-form v-model="licvalid">
                <v-file-input :rules="[sizerules, form_rules.required]" @change="checkLic" accept="image/*, .pdf" placeholder="Pick a file" prepend-icon="mdi-certificate-outline" label="Licence File" ref="licence"></v-file-input>
                <v-btn small class="pull-right" :disabled="!licvalid" @click="uploadLicence">Upload</v-btn><br>
              </v-form>
              <hr class="transparent">
            </v-sheet>
            <v-divider></v-divider>
            <wallet-component :balance="balance" :wallets="wallets" :credits="credits" :debits="debits"></wallet-component>
          </v-sheet>
          <div v-else>
            <create-pro-account :professions="professions" v-if="create" :diagnostic_kits="diagnostic_kits"></create-pro-account>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/User'
  const ViewProfessional =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/show')
  const CreateProAccount =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "professionals" */ '@/Components/Professionals/create')
  const WalletComponent = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "wallets" */ '@/Components/Wallets/wallet')

  export default {
    name: 'ProfessionalView',
    layout,
    props: [
      'professional',
      'professions',
      'diagnostic_kits',
      'balance',
      'credits',
      'debits',
    ],
    components: {
      ViewProfessional,
      CreateProAccount,
      WalletComponent,
    },
    metaInfo () {
      return {
        title: 'View Professional',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        create: false,
        headers: [
          {
            text: 'Date', value: 'id'
          },
          {
            text: 'Location', value: 'location'
          },
          {
            text: 'Package', value: 'package.name'
          },
          {
            text: 'Cost', value: 'cost',
          },
          {
            text: 'Visited', value: 'visit_id'
          }
        ],
        filterBy: '',
        sizerules: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
        form: this.$inertia.form({
          '_method': 'PUT',
          photo: '',
          name: this.professional?.name,
          identification: this.professional?.identification,
          date_of_birth: this.professional?.date_of_birth,
          phone: this.professional?.phone,
        }),
        valid: false,
        licence: this.$inertia.form({
          licence_file: ''
        }),
        licvalid: false,
      }
    },
    methods: {
      checkImage (e) {
        console.log(e)
        // if (this.valid) {
          this.form.photo = e
        // }
      },
      saveImage (e) {
        e.preventDefault()
        this.form.post('/professionals/' + this.professional.id, {
          preserveScroll: true,
          preserveState: true,
        })
      },
      checkLic (e) {
        this.licence.licence_file = e
      },
      uploadLicence (e) {
        e.preventDefault()
        this.licence.post('/user/professional/licence/' + this.professional.id, {
          preserveScroll: true,
          preserveState: true,
        })
      }
    },
    computed: {
      service_requests () {
        return this.professional.service_requests
      },
      wallets () {
        return this.professional.wallets
      }
    },
    watch: {
      'professional.id': function (value) {
        if (value) {
          this.create = false
        }
      },
    }
  }
</script>
